import CancelAssessment from "../../../../assets/images/pre-assessment.svg";

import Modal from "../../../modal/Modal";

import Button from "../ButtonComponent";

import { BUTTON_VARIANTS } from "../constant";

import styles from "./styles.module.scss";

const ExitLearningModal = (props) => {
  const {show , handleContinueLearning , handleExit} = props;

  return (
    <>
      <Modal visible={show}>
        <div className={styles["feedback-wrapper"]}>
          <div className={styles["success-image"]}>
            <img src={CancelAssessment} alt="success" />
          </div>
          <div className={styles.title}>Exit Learning?</div>
          <div className={styles.description}>
          You can return anytime to continue learning.
          </div>

          <div className={styles["button-wrapper"]}>
            <Button
              label="Continue Learning"
              buttonVariant={BUTTON_VARIANTS.PRIMARY}
              onClick={handleContinueLearning}
            />
            <Button
              label="Exit"
              buttonVariant={BUTTON_VARIANTS.SECONDARY}
              onClick={handleExit}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ExitLearningModal;
